import React, { useState } from "react";
import { createContext } from "react";
export const PatentContext = createContext();
export default function PatentContextProvider({ children }) {
  const [patentLicensingModal, setPatentLicensingModal] = useState(false);


  return (
    <PatentContext.Provider
      value={{
        patentLicensingModal,
        setPatentLicensingModal,
      }}
    >
      {children}
    </PatentContext.Provider>
  );
}
